import Debug from 'debug'
import RESTResource from '../rest/RESTResource.js'
import protectedSymbol from '../util/protected.js'

const debug = Debug('cbio.Region')

export default class Region extends RESTResource {
  constructor (api, resource = {}) {
    super(api, resource)
    debug('constructed Region')
  }

  static url (state = {}) {
    return `/api/1/regions/${state.id || ''}`
  }

  get id () {
    return this[protectedSymbol].field('id')
  }

  get type () {
    return this[protectedSymbol].field('type')
  }

  toJSON = () => {
    return {
      id: this.id,
      type: this.type
    }
  }
}
